import React from 'react';

export default function FwAtSignIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-at' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
